import { stringValidator } from '#validation/common/validators';
export const storageAccessKeyIdValidator = stringValidator({
    requiredError: 'internal.key.required',
});
